import React from 'react'
import ResetPasswordForm from './components/ResetPasswordForm'

const ResetPassword = () => {
  return (
    <>
    <div className="text-center">
        <h3>Reset password</h3>
      </div>
      <ResetPasswordForm />
    </>
  )
}

export default ResetPassword